import { Modal } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { WantedListing } from '../../models/wantedListings.model';

import { AddWantedListingForm } from './AddWantedListingForm';

interface EditWantedListingModalProps {
  visible: boolean;
  onClose: () => void;
  listing: WantedListing;
}

export const EditWantedListingModal: React.FC<EditWantedListingModalProps> = ({ visible, onClose, listing }) => {
  const { t } = useTranslation('wanted-listings');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSuccess = () => {
    setRefreshKey((prev) => prev + 1);
    onClose();
  };

  return (
    <Modal title={t('EDIT_MODAL.TITLE')} open={visible} onCancel={onClose} footer={null} width={800} destroyOnClose>
      <AddWantedListingForm key={refreshKey} onSuccess={handleSuccess} mode="edit" existingListing={listing} />
    </Modal>
  );
};
